import { Roles } from "../../constants/roles";

function navigate(params: URLSearchParams): void {
    params.delete("page");
    const qs = params.toString();
    window.location.href = window.location.pathname + (qs ? "?" + qs : "");
}

export function initBrandsSidebar(root: Element): void {
    // Country / initial / priority filter items (single-select toggle)
    root.querySelectorAll<HTMLElement>(`[data-role="${Roles.BRANDS_SIDEBAR_FILTER_ITEM}"]`).forEach((btn) => {
        btn.addEventListener("click", () => {
            const param = btn.dataset.filterParam ?? "";
            const value = btn.dataset.filterValue ?? "";
            const isActive = btn.dataset.isActive === "1";
            const params = new URLSearchParams(window.location.search);
            if (isActive) {
                params.delete(param);
            } else {
                params.set(param, value);
            }
            navigate(params);
        });
    });

    // Keyword search — navigate on Enter or via the explicit search button.
    const keyword = root.querySelector<HTMLInputElement>(`[data-role="${Roles.BRANDS_SIDEBAR_KEYWORD}"]`);
    const keywordClear = root.querySelector<HTMLElement>(`[data-role="${Roles.BRANDS_SIDEBAR_KEYWORD_CLEAR}"]`);
    const keywordSubmit = root.querySelector<HTMLElement>(`[data-role="${Roles.BRANDS_SIDEBAR_KEYWORD_SUBMIT}"]`);

    const submitKeyword = (): void => {
        if (!keyword) return;
        const params = new URLSearchParams(window.location.search);
        const val = keyword.value.trim();
        if (val) {
            params.set("search", val);
        } else {
            params.delete("search");
        }
        navigate(params);
    };

    if (keyword) {
        keyword.addEventListener("keydown", (e) => {
            if (e.key !== "Enter") return;
            e.preventDefault();
            submitKeyword();
        });

        keyword.addEventListener("input", () => {
            if (keywordClear) keywordClear.hidden = keyword.value === "";
        });
    }

    if (keywordSubmit) {
        keywordSubmit.addEventListener("click", () => submitKeyword());
    }

    if (keywordClear) {
        // ISS-04-075: only clears the textbox — doesn't navigate/re-run the search.
        keywordClear.addEventListener("click", () => {
            if (keyword) {
                keyword.value = "";
                keyword.focus();
            }
            keywordClear.hidden = true;
        });
    }

    // Clear all filters
    root.querySelectorAll<HTMLElement>(`[data-role="${Roles.BRANDS_SIDEBAR_CLEAR}"]`).forEach((btn) => {
        btn.addEventListener("click", (e) => {
            e.preventDefault();
            window.location.href = window.location.pathname;
        });
    });

    // ISS-04-075: whole filter section (search + filters) collapses as one panel.
    const toggle = root.querySelector<HTMLElement>(`[data-role="${Roles.BRANDS_SIDEBAR_TOGGLE}"]`);
    const panel = root.querySelector<HTMLElement>(`[data-role="${Roles.BRANDS_SIDEBAR_PANEL}"]`);
    if (toggle && panel) {
        toggle.addEventListener("click", () => {
            const isOpen = panel.classList.toggle("is-open");
            toggle.setAttribute("aria-expanded", isOpen ? "true" : "false");
        });
    }
}
